module.exports = __webpack_public_path__ + "img/i.7d4600b1.jpg";